// define custom attributes reducers.
import CustomAttrConst from '../constants/customAttributes.constants';

const CustomWorkstreamsAttr = (state = {}, action) => {
  // console.log("customAttributesReducers");
  const initialState = state;
  switch (action.type) {
    case CustomAttrConst.SET_INITIAL_DATA:
			state = { ...state, ...action.data };
      break;
    case CustomAttrConst.CUSTOM_CATEGORY_ADD:
      if (Object.keys(action.value).length) {
        initialState.category.unshift(action.value);
        initialState.custom_attribs.unshift(action.value);
        state = Object.assign({}, state, initialState);
      }
      break;
    case CustomAttrConst.CUSTOM_CATEGORY_UPDATE:
      initialState.category = initialState.category.map((item) => {
        if (item.id == action.tempid) {
          item = Object.assign({}, item, action.value);
        }
        return item;
      });
      state = { ...state, initialState };
      break;


    case CustomAttrConst.CUSTOM_CATEGORY_DELETE:
      if (action.del_type == 0) { // Delete category but keep custom attributes
        let attributes;
        let uncatAttr = false;
        initialState.custom_attribs = initialState.custom_attribs.map((item) => {
          if (item.id == -1) {
            uncatAttr = true;
          }
          if (item.id == action.id) {
            attributes = item.attributes;
          }
          return item;
        });
        initialState.custom_attribs = initialState.custom_attribs.map((item) => {
          if (item.id == -1) {
            if (uncatAttr) {
              $.merge(item.attributes, attributes);
            }
          } else if (!uncatAttr) {
            const custom_attribs = {
              id: -1,
              description: '',
              name: 'Ungrouped Attributes',
              attributes: [],
              display: 1,
            };
            Object.assign(custom_attribs.attributes, attributes);
            item = Object.assign({}, item, custom_attribs);
          }
          return item;
        });
      }// else if(action.del_type == 1){//Delete category and delete all the custom attributes in the category
      // }
      initialState.custom_attribs = initialState.custom_attribs.filter(obj => (obj.id != action.id));
      initialState.category = initialState.category.filter(obj => (obj.id != action.id));
      state = { ...state, initialState };
      break;


    case CustomAttrConst.CUSTOM_ATTRIBUTES_ADD:
      let uncat = 0;
      if (Object.keys(action.value).length) {
        initialState.custom_attribs = initialState.custom_attribs.map((item) => {
          if (item.id == action.cat_id) {
            uncat = 1;
            item.attributes.unshift(action.value);
          }
          if ((item.id == -1) && action.cat_id == '') {
            uncat = -1;
            item.attributes.unshift(action.value);
          }
          return item;
        });
        if (uncat == 0) {
          let custom_attribs = {};
          if (action.cat_id == '' || action.cat_id == null || action.cat_id == -1) {
            custom_attribs = {
              id: -1,
              description: '',
              name: 'Ungrouped Attributes',
              attributes: [],
              display: 1,
            };
          } else {
            custom_attribs = {
              id: action.cat_id,
              description: '',
              name: action.value.categoryName,
              attributes: [],
              display: 1,
            };
          }
          custom_attribs.attributes.push(action.value);
          initialState.custom_attribs.push(custom_attribs);
          Object.assign({}, initialState.custom_attribs, custom_attribs);
        }
        state = { ...state, initialState };
      }
      break;


    case CustomAttrConst.CUSTOM_ATTRIBUTES_EDIT:
      let notAdd = false;
      const unCate = false;
      initialState.custom_attribs = initialState.custom_attribs.map((item) => {
        if (item.id == -1 || item.id == null) {
          uncat = true;
        }
        if (item.id == action.cat_id && action.oldCatId == action.cat_id) {
          const f = item.attributes.map((fileds) => {
            if (fileds.id == action.id) {
              notAdd = true;
              Object.assign(fileds, action.items);
              return fileds;
            }
          });
        } else if (item.id == action.cat_id && action.oldCatId != action.cat_id) {
          notAdd = true;
          item.attributes.unshift(action.items);
        }
        return item;
      });
      if ((!action.cat_id || action.cat_id == -1) && !notAdd) {
        const custom_attribs = {
          id: -1,
          description: '',
          name: 'Ungrouped Attributes',
          attributes: [],
          display: 1,
        };
        if (!uncat) {
          custom_attribs.attributes.push(action.items);
          initialState.custom_attribs.push(custom_attribs);
          Object.assign({}, initialState.custom_attribs, custom_attribs);
        }
      }
      state = { ...state, initialState };
      break;

    case CustomAttrConst.CUSTOM_ATTRIBUTES_DELETE:
      if (action.del_type == 2) {
        let delUncat = false;
        initialState.custom_attribs = initialState.custom_attribs.map((item) => {
          if (item.id == action.cat_id) {
            item.attributes = item.attributes.filter(obj => (obj.id != action.id));
          }
          if (action.cat_id == -1 && item.attributes.length == 0) {
            delUncat = true;
          }
          return item;
        });
        if (delUncat) {
          initialState.custom_attribs = initialState.custom_attribs.filter(obj => (obj.id != -1));
        }
      } else if (action.del_type == 1) {
        initialState.custom_attribs = initialState.custom_attribs.filter(obj => (obj.id != action.id));
      }
      state = { ...state, initialState };
      break;

    case CustomAttrConst.CUSTOM_CATEGORY_EDIT:// working fine
      initialState.custom_attribs = initialState.custom_attribs.map((item) => {
        if (item.id == action.id) {
          item.name = action.name;
          item.description = action.description;
        }
        return item;
      });
      initialState.category = initialState.category.map((item) => {
        if (item.id == action.id) {
          item.name = action.name;
          item = Object.assign({}, item, action.value);
        }
        return item;
      });
      state = { ...state, initialState };
      break;

    case CustomAttrConst.ORG_ENG_UPDATE:
      if (Object.keys(action.value).length) {
        initialState.org_engagement = {};
        initialState.org_engagement = Object.assign({}, initialState.org_engagement, action.value);
        state = { ...state, initialState };
      }
      break;

    // return state;
    default:
      break;
  }
  return state;
};

export default CustomWorkstreamsAttr;
